import * as React from 'react';
import './Inicio.css';
import { Form, Formik } from 'formik';
import { validationForm } from './ValidationForm';
import CustomSelect from '../CustomFields/CustomSelect';
import CustomTextField from "../CustomFields/CustomTextField";
import { Button, Grid } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';
import { CMB_MENOS_UNO, INTER_CONTRATANE } from '../Utils/Constantes';
import FormDialog from '../Commons/FormDialog';
import FormDialogContacto from './FormDialogContacto';
import Api from '../Api/Api';
import { validaResponse } from '../Utils/Utils';

export default function FormInicio(props) {
  const navigate = useNavigate();
  const [openFormModal, setOpenFormModal] = React.useState(false);
  const handleOnChangeTipoContacto = (event, setFieldValue) => {
    const { target: { value, name } } = event;
    setFieldValue(name, value);
    sessionStorage.setItem("tipoContacto",value);
    if(value !== -1) {
      sessionStorage.setItem("tipoContacto",value);
      handleClickOpen();
    }
  };

  const handleClickOpen = () => {
    setOpenFormModal(true);
  };

  const DialogoContacto = () =>{
    return <FormDialogContacto handleClose={handleClickClose}/>;
  };

  const handleClickClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpenFormModal(false);
    }
  };
  
  const handleContinuar = (values, setSubmitting) => {
    let contratante = {};
    if (sessionStorage.getItem(INTER_CONTRATANE)) {
      contratante = JSON.parse(sessionStorage.getItem(INTER_CONTRATANE));
    }
    contratante = {
      nombre: values.nombre,
      tipoContacto: values.tipoContacto,
      telefono: contratante.telefono,
      correo: contratante.correo,
      ultimoPaso: 0
    };
    window.sessionStorage.setItem(INTER_CONTRATANE,JSON.stringify(contratante));
    inicioLead(contratante);
    setSubmitting(false);
    navigate('/Bienvenida');
  };

  const inicioLead = (contratante) => {
		Api.guardaContratante(contratante)
		.then(res => {
      if(validaResponse(res)){
        Api.getContratante(res.data.folio)
        .then(res => {
          window.sessionStorage.setItem(INTER_CONTRATANE,JSON.stringify(res.data.contratante));
        })
        .catch(error => {
          console.log(error);
        });
      } else {
        console.log("error",res);
      }
		})
		.catch(error => {
			console.log(error);
		});
  };

  return (
    <>    
      <FormDialog open={openFormModal} handleClose={handleClickClose} component={DialogoContacto} maxWidth="sm"/>
      <Formik validateOnChange={true}
        initialValues={{
          nombre: '',
          tipoContacto: -1,
        }}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true);
          handleContinuar(values, setSubmitting);
        }}
        validationSchema={validationForm}>
        {({ values, submitForm, setFieldValue, handleChange, errors, isSubmitting, setFieldError }) => (
          <Form>
            <Grid container direction="column" justifyContent="center" alignItems="center" spacing={4}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
              <div className="form-titulo">Estamos listos para garantizarte la mejor experiencia.</div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
              <div className="label-input mX-10">¿Cu&aacute;l es tu nombre?</div>
              <CustomTextField id="nombre" name="nombre" type="text" placeholder="Nombre" className="grid-item-input"/>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
              <div className="label-input mX-10">¿Si llegas a tener dudas, ¿C&oacute;mo prefieres que te asesoremos?</div>
              <CustomSelect id="tipoContacto" name="tipoContacto" className="grid-item-select w-100"
                onChange={(event) => handleOnChangeTipoContacto(event, setFieldValue)}>
                <MenuItem value={CMB_MENOS_UNO}>Seleccionar</MenuItem>
                <MenuItem value={0}>Tel&eacute;fono</MenuItem>
                <MenuItem value={1}>Whatsapp</MenuItem>
                <MenuItem value={2}>Email</MenuItem>
              </CustomSelect>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100 pt-0px">
              <Grid container direction="column" alignItems="flex-end" justifyContent="flex-end" className="w-100">
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                  <Button onClick={(event) => props.handleTipoForm(true)} className="texto-numero-cotizacion">
                  ¿Ya tienes un n&uacute;mero de cotizaci&oacute;n?
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="w-100">
              <Button variant="contained" disableElevation endIcon={<ArrowForwardIcon />} className="button-continuar w-100"
                onClick={submitForm} disabled={isSubmitting}>
                ¡Estoy list@!
              </Button>
            </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </>
  );
}